const isPro = function(user) {
  if (!user.subscriptionExpirationDate) {
    return false;
  }

  if (typeof user.subscriptionExpirationDate !== 'string') {
    return false;
  }

  const now = Date.now();

  const subscriptionExpirationDate = new Date(user.subscriptionExpirationDate);
  if (!subscriptionExpirationDate) {
    return false;
  }

  return subscriptionExpirationDate.getTime() >= now;
};

const sortUserByFullName = function(firstUser, secondUser) {
  const firstUserFullName = `${firstUser.firstName} ${firstUser.lastName}`;
  const secondUserFullName = `${secondUser.firstName} ${secondUser.lastName}`;

  return firstUserFullName.localeCompare(secondUserFullName);
}

export { isPro, sortUserByFullName };
